import route from "../../router";
import moment from "../../plugins/moment";
import { mapGetters } from "vuex";
import { GET_LOADING } from "../../store/getter-types";
import { NIGHTS_GET_IS_PACK_FLIGHT } from "../../store/nights/getter-types";
import * as SEARCH_GETTERS from "../../store/search/getter-types";
import * as BOOKING_GETTERS from "../../store/booking/getter-types";
import * as BOOKING_ACTIONS from "../../store/booking/action-types";
import * as DESTINIES_GETTERS from "../../store/destinies/getter-types";
import * as DESTINIES_ACTIONS from "../../store/destinies/action-types";
import Axios from "axios";
import { UPDATE_FLIGHT } from "../../store/destinies/mutation-types";

export default {
  computed: {
    ...mapGetters({
      loadingCalendar: GET_LOADING,
      search: SEARCH_GETTERS.GET_SEARCH,
      booking: BOOKING_GETTERS.GET_BOOKING,
      totalPrice: BOOKING_GETTERS.GET_BOOKING_TOTAL_PRICE,
      travellersTotal: BOOKING_GETTERS.GET_BOOKING_TRAVELLERS_TOTAL,
      bookingDate: BOOKING_GETTERS.GET_BOOKING_DATE,
      destinies: DESTINIES_GETTERS.GET_DESTINIES,
      typeDates: DESTINIES_GETTERS.GET_TYPE_DATES,
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT
    })
  },
  data: () => ({
    isValid: false,
    destinyLabel: "",
    daysSelectedLoading: [],
  }),
  created() {
    if (this.search.destiny && this.search.destiny.name) {
      this.destinyLabel = this.search.destiny.name;
    } else {
      let that = this;
      Axios.get("/api/locations/" + route.currentRoute.params.destiny)
        .then(function(res) {
          that.destinyLabel = res.data.name;
        });
    }
    const params = {
      origin: route.currentRoute.params.origin,
      destiny: route.currentRoute.params.destiny,
      adults: 2,
      children: 0,
      babies: 0,
    };
    this.$store
      .dispatch(DESTINIES_ACTIONS.FETCH_TRIPS, params)
      .then(() => {
        this.$store.dispatch(DESTINIES_ACTIONS.FETCH_FLIGHTS, params);
        this.destinyLabel = this.destinyLabel || this.$store.getters[DESTINIES_GETTERS.GET_TRIP].destination.name;
      })
      .catch(error => {
        setTimeout(() => {
          this.$toastr.e(
            window.i18n.t('toast.error_3')
          );
          route.push({ name: "home-when" });
        }, 800);
      });
  },
  methods: {
    async selectTrip(event) {
      const dateFrom = moment(event.dateFrom).format("YYYY-MM-DD")
      this.daysSelectedLoading.push(dateFrom)

      const params = {
        origin: route.currentRoute.params.origin,
        destiny: route.currentRoute.params.destiny,
        date: dateFrom,
        adults: route.currentRoute.query.adults,
        children: route.currentRoute.query.childs,
        babies: route.currentRoute.query.babies
      }


      this.destinies.flights.forEach(async (days, index) => {
        if (index == event.id) {
          let trip = days[1][0];

          if(!trip.departureToken){
            const response = await this.$store.dispatch(DESTINIES_ACTIONS.CHECK_TRIP, params);
            trip= response[0];
            this.$store.commit(UPDATE_FLIGHT, {index,price: trip.price});
          }

          const booking = {
            departureToken: trip.departureToken,
            travellerPrice: parseFloat(trip.price),
            travellers: {
              adults: {
                total: parseInt(route.currentRoute.query.adults),
                data: {}
              },
              childs: {
                total: parseInt(route.currentRoute.query.childs),
                data: {}
              },
              babies: {
                total: parseInt(route.currentRoute.query.babies),
                data: {}
              }
            },
            outgoingFlight: {
              departure: {
                code: this.$route.params.origin,
                airport: trip.airportFrom,
                name: trip.cityCodeFrom,
                datetime: moment(
                  trip.journeyFlightDepartureTime,
                  "YYYY-MM-DDTHH:mm:ss"
                )
              },
              arrival: {
                code: this.$route.params.destiny,
                airport: trip.airportTo,
                name: trip.cityCodeTo,
                datetime: moment(
                  trip.journeyFlightArrivalTime,
                  "YYYY-MM-DDTHH:mm:ss"
                )
              }
            },
            extras: {
              ...this.booking.extras,
              available: []
            },
          };

          this.$store.dispatch(BOOKING_ACTIONS.SET_BOOKING, booking);
          this.isValid = true;
          this.daysSelectedLoading = [];
          return;
        }
      });
    },
    handleClick() {
      const origin = this.$route.params.origin;
      const destiny = this.$route.params.destiny;
      const dateOfFlight = this.booking.outgoingFlight.departure.datetime.format(
        "DD-MM-YYYY"
      );
      this.$store.dispatch(BOOKING_ACTIONS.SET_BOOKING_LOADING, true);
      setTimeout(() => {
        this.$store.dispatch(BOOKING_ACTIONS.SET_BOOKING_LOADING, false);

        window.location.href = `/viaje/checkout/detalles?origen=${origin}&destino=${destiny}&airlines=FR&adults=${this.booking.travellers.adults.total}&childs=${this.booking.travellers.childs.total}&babies=${this.booking.travellers.babies.total}&fecha=${dateOfFlight}&precio=${this.totalPrice}&departureToken=${this.booking.departureToken}`
      }, 800);
    }
  }
};
